import { render, staticRenderFns } from "./support_comment.vue?vue&type=template&id=75123510&scoped=true&"
import script from "./support_comment.vue?vue&type=script&lang=js&"
export * from "./support_comment.vue?vue&type=script&lang=js&"
import style0 from "./support_comment.vue?vue&type=style&index=0&id=75123510&prod&lang=css&"
import style1 from "./support_comment.vue?vue&type=style&index=1&id=75123510&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75123510",
  null
  
)

export default component.exports